import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComplianceSuiteComponent } from "./compliance-suite.component";

const routes: Routes = [{ path: '', component: ComplianceSuiteComponent, data: { titleKey: 'TITLE.COMPLIANCE_SUITE', ogKey: 'COMPLIANCE_SUITE' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComplianceSuiteRoutingModule { }

